import React from 'react'
import { ParticipantList } from 'src/pages/worldCup2026/participants/list'

export const WorldCup2026ParticipantsPage = () => {
  return <ParticipantList />
}
